module.exports = __webpack_public_path__ + "img/gm.1d31f048.svg";